module.exports = __webpack_public_path__ + "img/gpaysafe.4e35aa60.svg";